import { apiClient } from '@copro/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { useSpace } from '../../../hooks/useSpace';
import { keys } from './keys';

type Command = {
  /** Updates this expense when set, creates one otherwise. */
  expenseId?: string;
  categoryId: string;
  amount: number;
  /** First day of the month, `yyyy-MM-dd`. */
  month: string;
};

async function saveExpense(command: Command) {
  const row = {
    category_id: command.categoryId,
    amount: command.amount,
    month: command.month,
  };

  const { error } = command.expenseId
    ? await apiClient.from('expenses').update(row).eq('id', command.expenseId)
    : await apiClient.from('expenses').insert(row);

  if (error) {
    throw error;
  }
}

export function useSaveExpense() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: saveExpense,
    onSuccess: (_data, command) => {
      queryClient.invalidateQueries({ queryKey: keys.expenses(currentSpace!.id) });
      enqueueSnackbar(command.expenseId ? 'Dépense modifiée.' : 'Dépense ajoutée.', 'success');
    },
  });
}
